<template>
  <v-app>
    <v-content>
      <core-toolbar  :class="windowClass" v-if="IsLoggedIn"/>
      <core-drawer v-if="IsLoggedIn"/>
      <core-view :class="windowClass"/>
      <core-footer/>
    </v-content>
       <v-snackbar
      v-model="showAlert"
      :color="alertColor"
      :timeout="2000"
       :top="'top'"
     >
      {{alertText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  name: 'App',
  components: {
  },

  data: () => ({
  }),
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  computed:{
      showAlert: {
        get () {
          return this.$store.state.show_alert
          },
          set (val) {
            this.setAlert(val)
          }
      },
      alertText() {
        return this.$store.state.alert_text
      },
      alertColor(){
          return this.$store.state.alert_color
      },
      windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      IsLoggedIn(){
         return this.$store.state.is_logged
      }
  },
  methods: {
    ...mapMutations(['setDrawer', 'setResponsive', 'setAlert']),
      onResponsiveInverted() {
          if (window.innerWidth < 991) {
           this.setResponsive(true)
          } else {
            this.setDrawer(true)
            this.setResponsive(false)
          }
    },
  }

};
</script>
<style>

  #va-drawer, #va-toolbar {
    text-transform: uppercase !important;
    
  }
  .va-not-reponsive {
    padding-left: 255px;
  }
  .va-table tbody td {
    font-size: .8em !important;
  }
  @media print {
    
    .va-table  thead td {
    font-size: 12px !important;
  }
   .va-table  tbody td {
    font-size: 12px !important;
    height: 10px !important;
  }
   .va-table  tfoot td {
    font-size: 12px !important;
  }
}
.va-table-border-bot {
  width: 100%;
}
.va-table-border-bot td {
  border-bottom: 1px solid #ddd;
}
  .va-underline {
    border-bottom: 1px solid #F96332;
  }
  .v-select__slot, .v-text-field__slot {
      font-size: .75em !important;
  }
  .v-btn__content {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .va-right input{
    text-align: right;
  }
  .table2 {
    width: 100%;

  }
.table2 td {
  border-bottom: 1px solid #ddd;
}
/* Drawer */
#va-drawer .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
#va-drawer .v-expansion-panels .v-expansion-panel {
  background: none !important;
  /* border-radius: 0 !important;
  -webkit-box-shadow:none !important; 
   box-shadow: none !important;  */
}
#va-drawer .v-expansion-panel::before {
  -webkit-box-shadow:none !important; 
   box-shadow: none !important;

}
.va-input-edit {
  border: 1px solid #F96332 !important;
  text-align: right !important;
  width: 60px;
  padding: 3px;
}
input[type="number"]:disabled {
    border: 0 !important;
}
.twrap  {

}
 .w100 {
 min-width: 700px;
 overflow-x: scroll;
}
.twrap-inner {
  min-width: 700px;
  overflow-x: scroll;
}
</style>